<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import SignUpFreeForm from "@/components/SignUpFreeForm.vue";

export default {
  title: "Sign Up for Free",
  name: "SignUpFree",
  page: {
    meta: [{ name: "description", content: "Sign Up for Free" }],
  },
  components: {
    Header,
    Footer,
    SignUpFreeForm,
  },
};
</script>
<template>
  <main>
    <Header />
    <div class="sign-up-free-form-container">
      <SignUpFreeForm />
    </div>
    <Footer />
  </main>
</template>
<style scoped lang="scss">
.sign-up-free-form-container {
    display: flex;
    justify-content: center;
}
</style>